'use client'
import { createContext, useState } from 'react'
import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'

type TypeContextData = {
  shouldFadeIn: boolean,
  setShouldFadeIn: Dispatch<SetStateAction<boolean>>
}

const initialContextData:TypeContextData = {
  shouldFadeIn: true,
  setShouldFadeIn: ()=> {}, 
}

interface Props {
  children: ReactNode
}

export const ShouldDisplayAnimationContext = createContext<TypeContextData>(initialContextData)
export const ShouldDisplayAnimationProvider: FC<Props> = ({ children }) => {
  const [shouldFadeIn, setShouldFadeIn] = useState<boolean>(true)
 
  return <ShouldDisplayAnimationContext.Provider value={{
    shouldFadeIn,
    setShouldFadeIn
  }}>{children}</ShouldDisplayAnimationContext.Provider>
}